import React from "react";
import PropTypes from "prop-types";

// styles
import * as styles from "./FourCards.module.css";

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      iconAlt: PropTypes.string,
    })
  ).isRequired,
  variant: PropTypes.oneOf(["default", "compact", "doctor"]),
};

const defaultProps = {
  variant: "default",
};

const FourCards = ({ cards, variant }) => {
  return (
    <div className={styles.cardsWrapper}>
      <div className="container">
        <div className={styles.cardsGrid}>
          {cards.map((card, index) => (
            <div key={index} className={`${styles.card} ${styles[variant]}`}>
              <div className={styles.cardIcon}>
                <img
                  src={card.icon}
                  alt={card.iconAlt || card.title}
                  className={styles.iconImage}
                />
              </div>
              <h3 className={styles.cardTitle}>{card.title}</h3>
              {card.description && (
                <p className={styles.cardDescription}>{card.description}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

FourCards.propTypes = propTypes;
FourCards.defaultProps = defaultProps;

export default FourCards;
